"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER_OF_RECIPIENTS_OPTIONS = exports.CAMPAIGN_PURPOSE_OPTIONS = exports.CUSTOM_CAMPAIGN_PURPOSE = void 0;
var CUSTOM_CAMPAIGN_PURPOSE = 'Other (you specify)';
exports.CUSTOM_CAMPAIGN_PURPOSE = CUSTOM_CAMPAIGN_PURPOSE;
var CAMPAIGN_PURPOSE_OPTIONS = ['Lead Gen/Door-Opener', 'Deal Acceleration', 'Lead Re-engagement', 'New Customer Welcome/Milestone', 'Celebration', 'Renewal/Retention', 'Customer Loyalty', 'Event Invitation', 'Event Follow-up', 'Partnership/Referral', 'HR', 'Thank you', 'Please Accept Our Apology', CUSTOM_CAMPAIGN_PURPOSE];
exports.CAMPAIGN_PURPOSE_OPTIONS = CAMPAIGN_PURPOSE_OPTIONS;
var NUMBER_OF_RECIPIENTS_OPTIONS = ['1-50', '51-250', '251-1000', '1001+', 'Unknown (Ongoing Campaign)'];
exports.NUMBER_OF_RECIPIENTS_OPTIONS = NUMBER_OF_RECIPIENTS_OPTIONS;